import { render, staticRenderFns } from "./CrmHistoryEvent.vue?vue&type=template&id=3036ec9a&scoped=true"
import script from "./CrmHistoryEvent.vue?vue&type=script&lang=ts"
export * from "./CrmHistoryEvent.vue?vue&type=script&lang=ts"
import style0 from "./CrmHistoryEvent.vue?vue&type=style&index=0&id=3036ec9a&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3036ec9a",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/winfakt/wf/v2.online.dev/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('3036ec9a')) {
      api.createRecord('3036ec9a', component.options)
    } else {
      api.reload('3036ec9a', component.options)
    }
    module.hot.accept("./CrmHistoryEvent.vue?vue&type=template&id=3036ec9a&scoped=true", function () {
      api.rerender('3036ec9a', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/crm/CrmHistoryEvent.vue"
export default component.exports